import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from "react-bootstrap";
import { connect } from 'react-redux';

import { extractCenterId } from "../../../utils/center";
import { MAIN_MODAL_HIDE } from '../../../actions/modal';
import { ORDER_CRATE_ADD, ORDER_CRATE_DELETE } from '../../../actions';
import { LOAD_FULL_STOCK_DOCK } from '../actions';

import CrateManagerTabs from '../../../common-comps/CratesManagerTabs';

class LoadingConfirmModal extends React.Component {
  render() {
    const { modal, hide, validate, currentCenterId, allCenters, addCrate, deleteCrate } = this.props;
    const currentCenter = allCenters.find(c => c.id === currentCenterId);
    const isCratesEnabled = currentCenter && currentCenter.crates_enabled;
    if (!modal.dock) {
      return null;
    }

    const { dock } = modal;
    let nbOfCrates;

    if (isCratesEnabled) {
      nbOfCrates = dock.tasks.reduce(
        (nb, task) => nb + task.linked_order.crates.length,
        0
      );
    } else {
      nbOfCrates = dock.tasks.reduce(
        (nb, task) => nb + task.linked_order.number_of_crates,
        0
      );
    }

    if (isCratesEnabled) {
      return (
        <Modal
          show={modal && modal.modalType === 'xd_full_stock_loading'}
          animation={false}
          backdrop={true}
          onHide={() => hide()}
          keyboard={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Validation du chargement</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Nombre de cagettes à charger: {nbOfCrates}</h4>
            {dock.tasks.map(({ linked_order: order }) => (
              <React.Fragment key={order.id}>
                <h5>{`Commande #${order.random_id}`}</h5>
                <CrateManagerTabs
                  order={order}
                  deleteCrate={(crateCode, orderId) => deleteCrate(crateCode, orderId, order)}
                  addCrate={({ crateCode, orderId }) => addCrate(crateCode, orderId, order)}
                />
              </React.Fragment>
            ))}
            <Button
              className="w-100 mb-5"
              variant="success"
              size="sm"
              onClick={() => validate(dock)}
            >
              Valider le chargement
            </Button>
          </Modal.Body>
        </Modal>
      );
    } else {
      return (
        <Modal
          show={modal && modal.modalType === 'xd_full_stock_loading'}
          animation={false}
          backdrop={true}
          onHide={() => hide()}
          keyboard={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Validation du chargement</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Nombre de cagettes à charger: {nbOfCrates}</h4>
            <Button
              className="w-100 mb-5"
              variant="success"
              size="sm"
              onClick={() => validate(dock)}
            >
              Valider le chargement
            </Button>
          </Modal.Body>
        </Modal>
      );
    }
  }
}

LoadingConfirmModal.propTypes = {
  modal: PropTypes.object,
  hide: PropTypes.func,
  validate: PropTypes.func,
  allCenters: PropTypes.array,
  currentCenterId: PropTypes.number,
  addCrate: PropTypes.func,
  deleteCrate: PropTypes.func,
};

export default connect(
  state => ({
    modal: state.m.modal,
    allCenters: state.m.metas.centers,
    currentCenterId: extractCenterId(state.user),
  }),
  dispatch => ({
    hide: () => dispatch({ type: MAIN_MODAL_HIDE }),
    validate: (dock) => dispatch({
      type: LOAD_FULL_STOCK_DOCK,
      dock,
    }),
    deleteCrate: (crateCode, orderId, order) => dispatch({ type: ORDER_CRATE_DELETE, orderId, crateCode, orderPatch: order }),
    addCrate: (crateCode, orderId, order) => dispatch({ type: ORDER_CRATE_ADD, orderId, crateCode, orderPatch: order }),
  })
)(LoadingConfirmModal);
